import React,{useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import './css/dashboard_style.css';
import TicketChart from './components/TicketChart.js';
import { FaPlusCircle } from 'react-icons/fa'; // icons
import { API_URL_BASE } from './config';

const DashboardHome = () => {
	const [refreshKey, setRefreshKey] = useState(0); // triggers re-run of useEffect
	const [loading, setLoading] = useState(true);
	const [token, setToken] = useState('');
	const [compName, setCompName] = useState('');
	const [events, setEvents] = useState([]);
	const [pastevents, setPastEvents] = useState([]);
	const [showCharts, setShowCharts] = useState(() => window.innerWidth >= 768); 
	const navigate = useNavigate();
	let eventSoldData = {};

	const COLORS = ["#0088FE", "#FF8042"]; // Blue for sold, orange for available
	
	// Step 1: Set token from localStorage
	useEffect(() => {
	  const storedToken = localStorage.getItem('token');
	  if (storedToken) {
	    setToken(storedToken);
	  } else {
	    // Optional: redirect to login or show fallback
	    console.warn("No login token found in localStorage");
	    setLoading(false);
		navigate("/");
	  }

	  if(localStorage.getItem('compName')) {
		setCompName(localStorage.getItem('compName'));
	  }
	  
	}, []);
	
	
	
	// Update automatically if user resizes (optional, improves UX)
	useEffect(() => {
	  const handleResize = () => {
	    if (window.innerWidth >= 768) {
	      setShowCharts(true); // always show on desktop
	    }
	  };
	  window.addEventListener("resize", handleResize);
	  return () => window.removeEventListener("resize", handleResize);
	}, []);
	
	
	// Step 2: Fetch events when token is set
	 useEffect(() => {
	   if (!token) return; // Don't run if token is not ready
	   
	   console.log("token - " + token);

	   fetch(API_URL_BASE + '/ticket.json', {
	     method: 'POST',
	     headers: {
	       'Content-Type': 'application/json',
	     },
	     body: JSON.stringify({
	       fetchevents: {
	           token: token
	       }
	     }),
	   })
	     .then((res) => {
	       if (!res.ok)  throw new Error(`Server error: ${res.status}`);
	       return res.json();
	     })
	     .then((result) => {
			console.log("Fetched events ", result.events.events);
			//setEvents(result.events.events);
			const startOfToday = new Date();
			startOfToday.setHours(0, 0, 0, 0);
			
			setPastEvents(result.events.events.filter(e => new Date(e.startdatetime).getTime() <= startOfToday.getTime()) || []);
			setEvents(result.events.events.filter(e => new Date(e.startdatetime).getTime() > startOfToday.getTime()) || []);
	     })
	     .catch((err) => {
	       console.error("Fetch error:", err);
		   navigate("/");
	     })
	     .finally(() => {
	       setLoading(false);
	     });

	 }, [token,refreshKey]); // 🔁 Runs whenever token or refreshkey is updated
	 
	 //Fetch event sold details
	 useEffect(() => {
	 if (!token) return; // Don't run if token is not ready

	   if (events && events.length > 0) {
	 fetch(API_URL_BASE + `/ticket.json`,{
	 method: 'POST',
	 	     headers: {
	 	       'Content-Type': 'application/json',
	 	     },
	 	     body: JSON.stringify({
	 	       fetchchartdata: {
	 	           token: token
	 	       }
	 	     }),
	 	   })
	     .then(res => {
	       if (!res.ok) throw new Error('Event not found');
	       return res.json();
	     })
	     .then(data => {
	 		
	 		console.log(data);
	 		if (data.eventchartdetail.eventchart && data.eventchartdetail.eventchart.length > 0) {
				data.eventchartdetail.eventchart.forEach((e) => {
					// Set value
					eventSoldData[e.eventid] = {
					  available: e.capacity - e.ticketsold,
					  sold: e.ticketsold
					};
					 					 
	 			});				
			}
			
			console.log(eventSoldData);

	     })
	     .catch(err => {
	       console.error('Error loading event:', err);
	      // setEventResult(null);
	     })
	     .finally(() => setLoading(false));
	     //setBarData(newBarData);
	   }
	 }, [events]);

	 
	 const handleCreateNewEvent = () => {
	    // setShowEventForm(true);
	 	navigate('/dashboard/events/new');
	 };
	 
	 
	 
return (
		<div className="container">
		    
		        <section className="main-content">
				<h2>{compName ? compName : null}</h2>
                    {/*<div className="notification">Don't forget to fill out your bank account details</div> */}
					{/* Header toggle (only visible on mobile) */}
					<div
					  className="chart-header"
					  onClick={() => {
					    if (window.innerWidth < 768) setShowCharts(!showCharts);
					  }}
					>
					  <h3>Analytics</h3>
					  <span className="chart-toggle-arrow">
					    {showCharts ? "▼" : "▶"}
					  </span>
					</div>
					
					{/* Chart container */}
					{showCharts && (
                    <div className="chart">
						<TicketChart 					
							events={events}
						/> 
					</div>
					)}
					
                    <div className="events">
                        <div className="upcoming">
                            <h3>Upcoming Events</h3>
							{loading ? (<p> Loading Events ....</p>) : (events.length > 0) ? 
								( 
									<div className="table-container">	 		     
									 <table className="dashboard-events-table">
									     <thead>
									         <tr>
											 <th>Event Name</th>
											 <th>Days Left</th>
									         </tr>
									     </thead>
									     <tbody>
									         {events.map(event => (
									             <tr key={event.hjid}>
									                 <td>{event.name}</td>
									                 <td>{Math.ceil((new Date(event.startdatetime) - new Date())/(1000 * 60 * 60 * 24))}</td>
													
									             </tr>
									         ))}
									     </tbody>
									 </table>
									 </div>
									 ) : <p>No upcoming events</p>}
                         
							<button className="create-event" onClick={handleCreateNewEvent}>
								<FaPlusCircle style={{paddingRight:'10px'}}/> Create New Event 
							</button>
                        </div>
                        <div className="past">
                            <h3>Past Events</h3>
							{loading ? (<p> Loading Past Events ....</p>) : (pastevents.length > 0) ? 
								(
									<div className="table-container">	 		     
									  <h1>{pastevents.length}</h1>
									 </div>
									 ) : <p>No events in past 14 days</p>}
                        </div>
                    </div>
                </section>
		</div>                                

);
 
}

export default DashboardHome;